export var nonTouchHoverMedia = '@media (hover: hover) and (pointer: fine)';
